"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.print = exports.fts = exports.find = exports.list = void 0;
const endpoint_1 = require("api/endpoint");
const permissions_1 = require("shared/permissions");
exports.list = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_NDC_READ,
    method: 'get',
    // options: { query: { start: number; count: number; search?: string } };
    path: 'ndc/list',
});
exports.find = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_NDC_UPDATE,
    method: 'put',
    path: 'ndc/find',
});
exports.fts = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_NDC_UPDATE,
    method: 'put',
    path: 'ndc/fts',
});
exports.print = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_NDC_UPDATE,
    method: 'put',
    path: 'ndc/print',
});



//////////////////
// WEBPACK FOOTER
// ./src/api/ndc/ndc-client.ts
// module id = 990
// module chunks = 0 1 2